<template>
    <m-dialog full-width :value="isDialogOpened" @update:returnValue="closeDialog(true, password)" :loading="loading" class="pa-0">
        <template>
            <v-layout class="pa0">
                <v-flex xs12 class="text-xs-right pa-0 ">
                    <e-button-close class="m-dialog__close mt-0" @click="closeDialog(true, password)"/>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 class="text-xs-center">
                    <e-typography-heading-3>
                        {{$t('modules.dialogs.m-dialog-user-generate-password.title')}}
                    </e-typography-heading-3>
                </v-flex>
                <v-flex xs12 class="mt-4 text-xs-center">
                    <e-typography-body-small>
                        {{$t('modules.dialogs.m-dialog-user-generate-password.text', {name: userFullName})}}
                    </e-typography-body-small>
                </v-flex>
                <v-flex xs12>
                    <e-input-text-copy-to-clipboard
                            readonly
                            :label="$t('modules.dialogs.m-dialog-user-generate-password.password.label')"
                            :value="password"/>
                </v-flex>
            </v-layout>
        </template>

        <template v-slot:actions>
            <v-layout>
                <v-flex class="text-xs-center">
                    <e-button-primary @click="closeDialog(true, password)">
                        {{$t('modules.dialogs.m-dialog-user-generate-password.button.text')}}
                    </e-button-primary>
                </v-flex>
            </v-layout>
        </template>
    </m-dialog>
</template>

<script>
    import {mapActions} from 'vuex';
    import passwordGenerator from "@utils/passwordGenerator";
    import vuexKeys from "@mixins/includes/_vuexKeys";
    import dialog from "@mixins/components/modules/dialogs/dialog";

    let name = 'm-dialog-user-generate-password';
    export default {
        name: name,
        inheritAttrs: false,
        mixins: [vuexKeys, dialog],
        data: () => ({
            password: ''
        }),
        props:{
            name:{
                type:String,
                default:name
            },
            type:{
                type:String,
                default: 'generatePassword'
            }

        },
        computed: {
            userFullName() {
                return !this.$lodash.isEmpty(this.user) ? this.user.firstName + ' ' + this.user.lastName: '' ;
            },
            user(){
               return !this.$lodash.isEmpty(this.payload) ? this.payload.user : {};
            },
            loading() {
                if (!this.$lodash.isEmpty(this.user)) {
                    return this.$wait.waiting(this.keys.users.update + this.user._id);
                }
                return false;
            }
        },
        watch: {
            isDialogOpened(to) {
                if (to === true) {
                    //TODO check this feature after needToChangePassword backend implementation
                    this.password = passwordGenerator.generate();
                    this.requestUpdateUser({_id: this.user._id, password: this.password, needToChangePassword: true});
                }
            }
        },
        methods: {
            ...mapActions({
                requestUpdateUser: 'users/update'
            }),
        }
    }
</script>

<style scoped>

</style>
